import { useState } from "react";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Highlighter from "react-highlight-words";
import { GoEye } from "react-icons/go";
import React from "react";
import Dependent_addition_ops1_Edit from "./dependent_addition_ops1_edit";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";

export default function DependentAddition_ops1({
  dependentDetails,
  setTrigger,
  trigger,
  setIndex,
  titles,
}) {
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(dependentDetails?.data || []);

  const formatDate = (dateString) => {
    // Create a new Date object from the given dateString
    const date = new Date(dateString);
    // Check if the date object is valid
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    // Define an array of month names
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = date.getDate();
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const formattedDate = `${day}-${monthName.toLowerCase()}-${year}`;

    return formattedDate;
  };
  const [searchWords, setSearchWords] = useState([]);

  const navigate = useNavigate();

  const location = useLocation();
  const [routeCheck, setRouteCheck] = useState(false);
  const [details, setDetails] = useState();
  const OnIconClick = (data) => {
    navigate("/dashboard/dependent-addition/ops1_edit");
    setDetails(data);
  };
  useEffect(() => {
    if (location.pathname.split("/")[3] === "ops1_edit") {
      setRouteCheck(true);
    } else {
      setRouteCheck(false);
    }
  }, [location]);
  console.log(
    "Location need to be seen here.....",
    location.pathname.split("/")[3]
  );
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/excelDownload/OPS1`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `OPS_2_REPORT`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  const [filter, setFilterDate] = useState();

  console.log("filter date should be poppulated here....", filter);
  const formattedInputDate = filter ? formatDate(filter) : "";

  // Filter the list based on the iqama expiry date if input date is provided
  const filteredList = !filter
    ? currentList
    : currentList.filter((list) => {
        const formattedIqamaExpiryDate = formatDate(list.iqama_expiry_date_g);
        return formattedIqamaExpiryDate === formattedInputDate;
      });
  return (
    <>
      {routeCheck ? (
        <Dependent_addition_ops1_Edit
          details={details}
          setTrigger={setTrigger}
          trigger={trigger}
          setIndex={setIndex}
        />
      ) : (
        <>
          <div className="flex gap-x-4 mt-4">
            <Search
              searchKey={[
                "request_type",
                "employee_name",
                "emp_id",
                "actual_profession",
                "nationality",
                "iqama_number",
              ]}
              setSearchWords={setSearchWords}
            />
            <button
              className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
              onClick={() => downloadFile()}
            >
              DOWNLOAD
            </button>
            <input
              type="date"
              className="px-4 rounded-md "
              onChange={(e) => {
                setFilterDate(e.target.value);
              }}
            />
          </div>

          <div
            className="overflow-x-auto mt-10"
            style={{ backgroundColor: "white" }}
          >
            <table className="min-w-full divide-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  {titles.map((columnName, index) => (
                    <th
                      key={index}
                      scope="col"
                      className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                    >
                      {columnName}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-gray-10">
                {filteredList?.map((listItem, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.request_type}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.employee_count
                        ? listItem?.employee_count
                        : "------"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.employee_name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.emp_id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.gender}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.nationality}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.actual_profession}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.client_name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.iqama_number}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {String(listItem.iqama_expiry_date_g)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.project}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.insurance_class}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <button
                        onClick={() => {
                          OnIconClick(listItem);
                        }}
                      >
                        <GoEye fontSize={22} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <Pagination />
        </>
      )}
    </>
  );
}
